export type YAxisConfig = {
  max: number;
  stepSize: number;
  ticks: number[];
};

export function getNiceMax(value: number): number {
  if (value <= 10) return 10;

  const step = 10;
  let nice = Math.ceil(value / step) * step;

  if (value % step === 0) {
    nice += step;
  }

  return nice;
}

export function getYAxisConfig(
  values: (number | null | undefined)[],
  opts?: { min?: number; ticksCount?: number }
): YAxisConfig {
  const { min = 0, ticksCount = 5 } = opts || {};

  const filtered = values.filter(
    (v): v is number => typeof v === 'number' && !isNaN(v)
  );

  const rawMax = filtered.length ? Math.max(...filtered) : 0;

  if (rawMax <= 1) {
    const max = 10;
    const stepSize = max / ticksCount;
    const ticks = Array.from({ length: ticksCount + 1 }, (_, i) =>
      Number((i * stepSize).toFixed(2))
    );
    return { max: 1, stepSize, ticks };
  }

  const niceMax = getNiceMax(rawMax);
  const stepSize = niceMax / ticksCount;

  const ticks: number[] = [];
  for (let v = min; v <= niceMax + 1e-9; v += stepSize) {
    ticks.push(Number(v.toFixed(0)));
  }

  return { max: niceMax, stepSize, ticks };
}

// const formatMonthLabel = (value: string): string => {
// TODO this was the issue for wrong dates
//   const d = new Date(value + '-01');
//   if (isNaN(d.getTime())) return value;
//
//   const monthShort = d.toLocaleString('default', { month: 'short' });
//   const year = d.getFullYear();
//   return `${monthShort} ${year}`;
// };

export const formatMonthLabel = (value: string): string => {
  const [year, month] = value.split('-');

  if (!year || !month) return value;

  const monthIndex = Number(month) - 1;
  if (monthIndex < 0 || monthIndex > 11) return value;

  const monthShort = new Intl.DateTimeFormat('en-US', {
    month: 'short',
  }).format(new Date(2000, monthIndex, 1));

  return `${monthShort} ${year}`;
};
